import React, { useState } from 'react';
import './style.css';
import Logo from "../../../assets/images/Vector.png";
import ChatSnap from "../../../assets/images/Group.png";
import { ReactComponent as ChatImg } from "../../../assets/images/Group.svg";
import { ReactComponent as TradeMark } from "../../../assets/images/trademark.svg";
import Mic from "../../../assets/images/microphone.png";
import Smiley from "../../../assets/images/smiley.png";
import Clip from "../../../assets/images/clip.png";
import { ReactComponent as Emoji } from "../../../assets/images/emoji.svg";
import { ReactComponent as Attachment } from "../../../assets/images/attachment.svg";
import { ReactComponent as Bubble } from "../../../assets/images/bubble.svg";
import Input from '../../common/InputField';

function PreviewOne({ logo, welcomeText, color, gradientOne, gradientTwo, alignment, placeholderText, bubble }) {

  return (
    <div className="previewOneWidget">

      <div style={{ margin: "0 auto", borderRadius: '8px', background: "#fff" }}>
        <div className="defaultColor boxTop" style={{ background: color ? color : `linear-gradient(125deg, #e6e6e6 0%, ${gradientOne} 50%, ${gradientTwo} 80%)`, display: 'flex', justifyContent: 'center', alignItems: 'center', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
          <img className="widgetLogo" style={{ width: '54px', height: '54px', borderRadius: '50%', objectFit: 'cover' }} src={logo || Logo} />
        </div>

        <div className="previewOneCenter">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <p className="welcomeText" style={{ fontWeight: '500', lineHeight: '18px', paddingBottom: '5px' }}>{welcomeText}</p>
            <p className="widgetSubtext" style={{ lineHeight: '18px' }}>Hold on one sec while we connect you.</p>
          </div>
          <img src={ChatSnap} className="chatSnap" alt="Logo" />
          <div className="trademark" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <TradeMark />
          </div>
        </div>

        <div className="chat-box-client-container">

          <input
            placeholder={placeholderText}
            className="input-main-message"
          />
          <div className="input-icons-div">
            <p>
              <img src={Mic} />
            </p>
            <p>
              <img src={Smiley} />
            </p>
            <p>
              <img src={Clip} />
            </p>
          </div>

        </div>

      </div>

      {bubble ? (
        <div className="defaultColor bubble" style={{ float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Logo} alt="Logo" style={{ height: '2.6vh' }} />
        </div>
      ) : (
        <div className="defaultColor bar" style={{ padding: '0 16px 0 12px', float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "28px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Logo} alt="Logo" style={{ height: '2.6vh' }} /><span className="barText" style={{ paddingLeft: '6px', lineHeight: '18px' }}>Chat with us</span>
        </div>
      )}

    </div>
  )
}

export default PreviewOne;